import React, { Component } from 'react';
import {
    Form, Input, Button, Select, Modal, InputNumber,
} from 'antd';

import 'antd/dist/antd.css';

const Option = Select.Option;
let show = {
    display: 'none',
};

function handleChange(value) {
    console.log(`selected ${value}`);
    if (value === 'Otro') {
        show = {
            display: 'block',
        };
    } else {
        show = {
            display: 'none',
        };
    }
}

function handleBlur() {
    console.log('blur');
}

function handleFocus() {
    console.log('focus');
}

class MachineLogAddView extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log(e);
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.handleSubmit(values);
                this.props.form.resetFields();
            }
        });
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        const { getFieldDecorator } = this.props.form;
        const { log } = this.props;
        return (
            <div>
                <Modal
                    title="Manejo de Bitacora"
                    visible={this.props.openForm}
                    onOk={this.handleOk}
                    onCancel={this.props.onCancel}
                    footer={null}
                >
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item
                            {...formItemLayout}
                            label="Tipo"
                        >
                            {getFieldDecorator('type', {
                                initialValue: (log != null) ? log.type : '',
                                rules: [{ required: true, message: 'Seleccione un Tipo' }],
                            })(
                                <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder="Selecciona un Tipo"
                                    optionFilterProp="children"
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    filterOption={(input, option) => option.props.children.toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value="Chequeo">
                                        Chequeo
                                    </Option>
                                    <Option value="Reparacion">
                                        Reparación
                                    </Option>
                                    <Option value="Informacion">
                                        Información
                                    </Option>
                                    <Option value="Mantenimiento">
                                        Mantenimiento
                                    </Option>
                                    <Option value="Otro">
                                        Otro
                                    </Option>
                                </Select>,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Otro"
                            style={show}
                        >
                            {getFieldDecorator('other', {
                                initialValue: (log != null) ? log.other : '',
                            })(
                                <Input />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Costo"
                        >
                            {getFieldDecorator('cost', {
                                initialValue: (log != null) ? log.cost : '',
                                rules: [{ required: true, message: 'Ingrese el costo' }],
                            })(
                                <InputNumber min={0} />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Descripción"
                        >
                            {getFieldDecorator('description', {
                                initialValue: (log != null) ? log.description : '',
                                rules: [{ required: true, message: 'Ingrese una descripción' }],
                            })(
                                <Input.TextArea rows={4} />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Ubicación"
                        >
                            {getFieldDecorator('location', {
                                initialValue: (log != null) ? log.location : '',
                                rules: [{ required: true, message: 'Ingrese una ubicación' }],
                            })(
                                <Input />,
                            )}
                        </Form.Item>
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" htmlType="submit" onClick={this.handleOk}>
                                Guardar
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(MachineLogAddView);



// WEBPACK FOOTER //
// ./src/components/views/MachineLogAddView.js